import React from 'react';
import { FIRMA } from '../data/firma';
import styles from '../css/modules/Footer.module.css';

/*
 * Stopka zawiera tylko to, co przewiduje spec sekcja 29: nazwe, adres,
 * telefon, e-mail, glowne uslugi, kontakt i dokumenty. Bez chmury tagow,
 * bez list archiwow, bez bloku nafaszerowanego slowami kluczowymi.
 * Dane pochodza z src/data/firma.js - jedno zrodlo NAP dla calego serwisu.
 */

const USLUGI = [
  { href: '/diagnoza-sensoryczna-olsztyn/', text: 'Diagnoza sensoryczna Olsztyn' },
  { href: '/terapia-integracji-sensorycznej-olsztyn/', text: 'Terapia integracji sensorycznej' },
  { href: '/terapia-reki/', text: 'Terapia ręki' },
  { href: '/trening-umiejetnosci-spolecznych/', text: 'Trening Umiejętności Społecznych' },
  { href: '/cennik/', text: 'Cennik' },
];

const GABINET = [
  { href: '/o-mnie/', text: 'O mnie' },
  { href: '/kontakt/', text: 'Kontakt i dojazd' },
  { href: '/faq/', text: 'FAQ' },
  { href: '/poradnie-psychologiczne/', text: 'Poradnie psychologiczno-pedagogiczne' },
  // Blog stoi na WordPressie pod /integracja-sensoryczna/ i az do teraz
  // jedyny link do niego z tego serwisu byl schowany w menu pod hamburgerem.
  // Ponad 500 tekstow wisialo wiec praktycznie bez linku ze stron ofertowych.
  { href: '/integracja-sensoryczna/', text: 'Poradnik o integracji sensorycznej' },
  { href: '/regulamin/', text: 'Regulamin', nofollow: true },
  { href: '/polityka-prywatnosci/', text: 'Polityka prywatności', nofollow: true },
];

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className={styles.footer} role="contentinfo">
      <div className={styles.inner}>
        <div className={styles.cols}>
          <div className={styles.col}>
            <h2 className={styles.colTitle}>{FIRMA.nazwa}</h2>
            <address className={styles.addr}>
              {FIRMA.ulica}
              <br />
              {FIRMA.kod} {FIRMA.miasto}
              <br />
              <a href={`tel:${FIRMA.telefonE164}`}>tel. {FIRMA.telefon}</a>
              <br />
              <a href={`mailto:${FIRMA.email}`}>{FIRMA.email}</a>
            </address>
          </div>

          <div className={styles.col}>
            <h2 className={styles.colTitle}>Usługi</h2>
            <ul className={styles.linkList}>
              {USLUGI.map((u) => (
                <li key={u.href}>
                  <a href={u.href}>{u.text}</a>
                </li>
              ))}
            </ul>
          </div>

          <div className={styles.col}>
            <h2 className={styles.colTitle}>Gabinet</h2>
            <ul className={styles.linkList}>
              {GABINET.map((g) => (
                <li key={g.href}>
                  <a href={g.href} rel={g.nofollow ? 'nofollow' : undefined}>
                    {g.text}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className={styles.copy}>
          © {year} {FIRMA.nazwa} - {FIRMA.miasto}
        </div>
      </div>
    </footer>
  );
}

export default Footer;
